'use client';
import AppsLayout from '@/layout/AppsLayout';

export default function Layout({ children }) {
  return <AppsLayout>{children}</AppsLayout>;
}
